import { createRoute, useNavigate } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { MudsPage } from '../../MudsPage'
import { editorSearchSchema } from '../search-schemas'

export const mudsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/muds',
  validateSearch: editorSearchSchema,
  component: MudsRouteComponent,
})

function MudsRouteComponent() {
  const search = mudsRoute.useSearch()
  const navigate = useNavigate()
  return (
    <MudsPage
      mudId={search().edit ?? null}
      create={search().new === 1}
      onOpen={(id) => navigate({ to: '/muds', search: { edit: id } })}
      onCreate={() => navigate({ to: '/muds', search: { new: 1 } })}
      onBack={() => navigate({ to: '/muds', search: {} })}
    />
  )
}
